import React from "react";
import { Checkbox, Modal, Tooltip } from "antd";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import styles from "./closeConfirmModal.module.scss";

interface CloseConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  content: string;
  loading?: boolean;
  showSkipNext?: boolean;
  skipNextChecked?: boolean;
  onSkipNextChange?: (checked: boolean) => void;
}

const CloseConfirmModal: React.FC<CloseConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  loading = false,
  showSkipNext = false,
  skipNextChecked = false,
  onSkipNextChange,
}) => {
  const t = useTranslation();

  return (
    <Modal
      open={open}
      className={styles.closeConfirmModal}
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      width={311}
      destroyOnClose={true}
    >
      <div className={styles.modalContent}>
        <div className={styles.title}>{title || t("cfd.tip") || "Tip"}</div>
        <div className={styles.content}>{content}</div>
      </div>
      {showSkipNext && (
        <div className={styles.skipToggle}>
          <Checkbox checked={skipNextChecked} onChange={(e) => onSkipNextChange?.(e.target.checked)}>
            {t("cfd.skipCloseConfirmNext")}
          </Checkbox>
          <Tooltip title={t("cfd.reEnableCloseConfirmTip")} placement="top" overlayClassName={styles.quickConfirmTooltip}>
            <span className={styles.quickConfirmInfoIcon}>i</span>
          </Tooltip>
        </div>
      )}
      <div className={styles.modalFooter}>
        <button type="button" className={styles.cancelBtn} onClick={onClose}>
          {t("cancel") || "Cancel"}
        </button>
        <button 
          type="button"
          className={styles.confirmBtn} 
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? t("cfd.submitting") : t("confirm") || "Confirm"}
        </button>
      </div>
    </Modal>
  );
};

export default CloseConfirmModal;
